/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const filter = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M12 4 4 19h16L12 4zm0 3.2 5.5 10.3H12V7.2z" />
	</SVG>
);

export default filter;
